import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import { Globe, BookmarkFill, Link45deg, Linkedin } from 'react-bootstrap-icons';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* --- Left Section --- */}
        <div className="footer-about">
          <h3>Prof. (Dr) Mallick</h3>
          <p>
            Dedicated to advancing healthcare innovation, research, and knowledge 
            through insightful articles and publications that inspire change in 
            the medical community.
          </p>
            <p>
           After NIT. Author of book :<a href="https://www.amazon.in/SMILES-Bridging-Invisible-Disabilities-Neurodiversity/dp/9371648988/ref=sr_1_1?crid=2XM82MFPKCEYW&dib=eyJ2IjoiMSJ9.PR4h5s955SoxLHfF2bnbVg.24G7HNO6kZQISyk7Z1pWZZPPw2xuREdk_ZpnSkTrx3Y&dib_tag=se&keywords=smiles+dubisetty&qid=1772879661&sprefix=smiles+dubisett%2Caps%2C711&sr=8-1" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}> SMILES: Bridging The Mile In Special Skills</a>
          </p>
        </div>

        {/* --- Middle Section: Quick Links --- */}
        <div className="footer-links">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/magazines">Magazines</Link></li>
            <li><Link to="/blogs">Blogs</Link></li>
            <li><Link to="/about">About Me</Link></li>
          </ul>
        </div>

        {/* --- Right Section: Contact / Social --- */}
        <div className="footer-contact">
          <h4>Contact</h4>
          <p>Email: info@openlibrary.in</p>
          <p>Location: Plot 13-9-123, PR Nagar X Roads, Erragadda, Hyderabad, India - 500018</p>
          <p>Mobile: +91 9849559676</p>

          <div className="social-icons">
                                                  <a href="https://www.linkedin.com/in/dubisetty/" aria-label="LinkedIn"rel="noopener noreferrer"  target="_blank" ><Linkedin /></a>

                                      <a href="https://www.iafindia.com/mr-mallikarjuna-rao-dubisetty/"aria-label="Globe" rel="noopener noreferrer"  target="_blank" ><Globe /></a>
                                      <a href="https://www.credly.com/users/mallikarjuna-rao-dubisetty/badges#credly" aria-label="BookmarkFill" target="_blank"  rel="noopener noreferrer"><BookmarkFill /></a>
                                      <a href="https://orcid.org/0009-0007-8737-8629" aria-label="Link45deg"  rel="noopener noreferrer" target="_blank"><Link45deg /></a>
                                  </div>
        </div>
      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} Prof. (Dr) Mallick. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
